<template>
    <v-sheet>
        <div
            v-if="!payment_url"
            class="d-flex flex-column justify-center fill-height"
        >
            <Loader />
            <div class="text-subtitle-1 bold px-4 text-center mb-4">
                <template v-if="!id">&nbsp;</template>
                <template v-else-if="selected_provider === 'swish'">{{ translate('common.open_swish_to_complete_payment') }}</template>
                <template v-else>{{ translate('common.waiting_for_direct_payment') }}</template>
            </div>
        </div>
        <iframe
            v-else
            :src="payment_url"
            height="500px"
            style="border: none"
            width="100%"
        />
    </v-sheet>
</template>

<script>
import { api_mixin } from '@old/mixins/api_mixin'
import { locales_mixin } from '@old/mixins/locales_mixin'
import { mapState } from 'vuex'
import Loader from '@old/components/Loader.vue'

export default {
    name: 'PaymentRequest',
    props: {
        payment_amount_and_currency: Object,
        selected_ocr: {
            type: String,
        },
        selected_provider: {
            type: String,
        },
        public_url: {
            type: Boolean,
        },
        mobile_number: {
            type: String,
        },
    },
    mixins: [api_mixin, locales_mixin],
    components: { Loader },
    data() {
        return {
            id: '',
            payment_url: '',
            interval: null,
        }
    },
    computed: {
        ...mapState(['public_token']),
    },
    watch: {},
    emits: ['feedback'],
    methods: {
        async post_payment_request() {
            const data = {
                provider: this.selected_provider,
                locale: 'sv_SE',
                ocr: this.selected_ocr,
                amount: this.payment_amount_and_currency.amount,
                currency: this.payment_amount_and_currency.currency
            }
            if (this.selected_provider === 'swish') {
                data['mobile_number'] = this.mobile_number.replaceAll(' ', '')
            }

            let response = {}

            if (this.public_url) {
                await this.get_public_token()
                response = await this.api_post({
                    url: `/public--payment-provider-requests`,
                    data: {
                        ...data,
                        token: this.public_token
                    },
                })
            } else {
                response = await this.api_post({
                    url: '/payment-provider--requests',
                    data: data,
                })
            }
            if (response.status === 200) {
                this.id = response.data.id
                this.payment_url = response.data.payment_url
                this.interval = setInterval(() => {
                    this.poll_payment_request()
                }, 3000)
            }
        },
        async poll_payment_request() {
            let response = {}
            if (this.public_url) {
                await this.get_public_token()
                response = await this.api_get({
                    url: `/public--payment-provider-requests/${this.id}/${this.public_token}`,
                })
            } else {
                response = await this.api_get({
                    url: `/payment-provider--requests/${this.id}`,
                })
            }
            if (response.status === 200) {
                const { status } = response.data
                switch (status) {
                    case 'paid':
                        this.clear_interval()
                        return this.$emit('feedback', 'paid')
                    case 'failed':
                        this.clear_interval()
                        return this.$emit('feedback', 'failed')
                    case 'canceled':
                        this.clear_interval()
                        return this.$emit('feedback', 'canceled')
                    default:
                        return
                }
            }
        },
        clear_interval() {
            clearInterval(this.interval)
            this.interval = null
        },
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {
        this.post_payment_request()
    },
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {
        this.clear_interval()
    },
}
</script>

<style scoped lang="sass"></style>
